import { atom } from 'jotai'
import { atomFamily } from 'jotai-family'

import type { MinNotionalByIndex } from '@/features/order/order-form/lib/min-notional'

/** Published by the order rows (which own the price/unit inputs), read by the submit button. */
export const orderFormMinNotionalAtomFamily = atomFamily((_cardId: string) =>
  atom<MinNotionalByIndex>({})
)
